import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { NovoInteresseContato } from '../../models/novos-interesses/novo-interesse-contato';

@Injectable({
  providedIn: 'root'
})

export class NovoInteresseService {
  private baseUrl: string;
  private headers = new HttpHeaders();

  constructor(
    private http: HttpClient,
    @Inject("BASE_URL") baseUrl: string,
    private toastr: ToastrService
  ) {
    this.baseUrl = baseUrl;
  }

  public getContatosByGuidClienteNapis(): Observable<NovoInteresseContato[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis")
    };

    return this.http.post<NovoInteresseContato[]>(this.baseUrl + "api/NovoInteresse/GetContatosByGuidClienteNapis", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");
        return of([]);
      })
    );
  }

  public updateContatoContatado(id: number, contatado: boolean): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id,
      "guidclientenapis": localStorage.getItem("guidclientenapis"),
      "contatado": contatado
    };

    return this.http.post<boolean>(this.baseUrl + "api/NovoInteresse/UpdateContatoContatado", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");
        return of(false);
      })
    );
  }
}
